// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/effects_editor/effects/templates/tremolo.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    effect_header_tag = marko_loadTag(require("./components/effect-header")),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("affe45"),
    marko_node0 = marko_createElement("div", {
        "class": "control-group"
      }, "2", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control"
        }, null, null, 3)
        .e("div", {
            "class": "label"
          }, null, null, 1)
          .t("Intensity")
        .e("div", {
            id: "intensity-slider",
            "class": "slider"
          }, null, null, 0)
        .e("input", {
            type: "text",
            id: "intensity-value",
            value: "0.3"
          }, null, null, 0)
      .e("div", {
          "class": "control"
        }, null, null, 3)
        .e("div", {
            "class": "label"
          }, null, null, 1)
          .t("Rate")
        .e("div", {
            id: "rate-slider",
            "class": "slider"
          }, null, null, 0)
        .e("input", {
            type: "text",
            id: "rate-value",
            value: "4"
          }, null, null, 0)
      .e("div", {
          "class": "control"
        }, null, null, 3)
        .e("div", {
            "class": "label"
          }, null, null, 1)
          .t("Stereo Phase")
        .e("div", {
            id: "stereo-slider",
            "class": "slider"
          }, null, null, 0)
        .e("input", {
            type: "text",
            id: "stereo-value",
            value: "0"
          }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": "effect-control-panel",
      "data-chain-index": "" + data.location.index
    }, "0", component);

  effect_header_tag({
      name: "Tremolo"
    }, out, __component, "1");

  out.n(marko_node0, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
